import React from 'react';
import classNames from 'classnames';

import SVG from 'components/base/SVG';

import css from './style.scss';

/** Contact Details banner: name + edit, or the add-name prompt (Figma 383:21139). */
const Hero = ({ showIdentity, name, companyName, onEdit }) => (
  <section className={css.hero}>
    <div className={classNames(css.heroBar, css.heroBar1)}>
      <span className={css.heroBarFill} />
    </div>
    <div className={classNames(css.heroBar, css.heroBar2)}>
      <span className={css.heroBarFill} />
    </div>
    <div className={classNames(css.heroBar, css.heroBar3)}>
      <span className={css.heroBarFill} />
    </div>

    <div className={classNames(css.heroContent, { [css.heroContentNew]: !showIdentity })}>
      {showIdentity ? (
        <>
          <div className={css.heroName}>
            {name}
            <button
              type="button"
              className={css.heroEdit}
              onClick={onEdit}
              title="Edit general information"
            >
              <SVG icon="cp-edit" className={css.heroEditIcon} />
            </button>
          </div>
          {!companyName ? null : <div className={css.heroCompany}>{companyName}</div>}
        </>
      ) : (
        <>
          <div className={css.heroPrompt}>Add name and company for this contact</div>
          <button type="button" className={css.btnAddNow} onClick={onEdit}>
            <SVG icon="cp-edit" className={css.btnAddNowIcon} />
            Add Now
          </button>
        </>
      )}
    </div>
  </section>
);

export default Hero;
